module.exports = __webpack_public_path__ + "static/media/WaterBottle-label.b5ed45f2.glb";